import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { SensorType, TypeCamaras } from "../../pages/camaras/interface/camara.interface";
import { SensorComponent } from "../Sensor";
import { MensajeComponent } from "../Mensajes";
import { EstadoComponent } from "../Estados";
import { SetPointComponent } from "../SetPoint";

import imageHistorico from '../images/Historicos40x40.jpg'


type CardProps = {
    propsCamara: TypeCamaras;
    onVerGrafico?: () => void;
}

export const SalaMaquinasComponent: React.FC<CardProps> = ({propsCamara, onVerGrafico}) => {

    return (

    <Box    
      sx={{
        border: "2px solid #828282",
        borderRadius: 2,
        padding: 2,
        marginBottom: 2,
        backgroundColor: "#fafafa",
      }}
    >
        {/* Parte superior: nombre + botón, centrado */}
        <Box
            display="flex"
            justifyContent="left"
            alignItems="center"
            gap={2} // Espacio entre nombre y botón
            mb={2}
        >
            <Typography 
                component="div"
                variant="h6" 
                fontWeight="bold"
            >
                {propsCamara.name}
            </Typography>

            <IconButton
                onClick={onVerGrafico}
                title="Ver gráfico"
                sx={{
                    width: 40,
                    height: 40,
                    border: '2px solid rgba(0, 0, 0, 0.3)',
                    borderRadius: 0,
                    backgroundImage: `url(${imageHistorico})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    '&:hover': {
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)', // Sombra al pasar el mouse
                        transform: 'scale(1.1)', // Efecto de aumento al hacer hover
                    },
                    transition: 'all 0.3s ease-in-out', // Transición suave de la sombra y el tamaño
                }}
            />      

        </Box>
 
        {/* Parte Sensores: hasta 8 subcomponentes */}
        <Box 
            display="grid" 
            gridTemplateColumns="repeat(auto-fill, minmax(120px, 1fr))" 
            gap={1}
            mb={2}
        >
            { propsCamara.sensores?.length > 0 ? (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra sensores de Temperatura
                    (
                        sensor?.tipo_sensor === SensorType.PRESION || 
                        sensor?.tipo_sensor === SensorType.TEMPERATURA ||
                        sensor?.tipo_sensor === SensorType.POTENCIA   
                    ) && 
                    (
                        <SensorComponent key={`${sensor.id}-temp`} propsSensor={sensor}/>
                    )
                ))
            ) : (
                <Box 
                    sx={{ flex: '1 1 auto', maxWidth: 100 }}
                >
                    <Typography variant="body2" color="textSecondary">
                        No hay sensores para mostrar.
                    </Typography>
                </Box>
            )}
        </Box>

        {/* Parte Muestra Set Point de Presion*/}
        <Box 
            display="flex"
            justifyContent="left"
            alignItems="center"
            gap={1} 
            mb={1}
        >
            { propsCamara.sensores?.length > 0 && (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra Mensaje de Funcionamiento
                    (
                        sensor?.tipo_sensor === SensorType.SET_POINT_PRESION ||
                        sensor?.tipo_sensor === SensorType.SET_POINT_TEMPERATURA   
                    ) && 
                    (
                        <SetPointComponent key={`${sensor.id}-sp`} propsSensor={sensor} />
                    ) 
                ))
            )}
        </Box>

        {/* Parte Estado Compresores, Bombas, etc*/}
        <Box 
            display="grid" 
            gridTemplateColumns="repeat(auto-fill, minmax(120px, 1fr))" 
            gap={1}
            mb={1}
        >
            { propsCamara.sensores?.length > 0 && (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra Estados de Ventiladores, solenoides 
                    (sensor?.tipo_sensor === SensorType.ESTADO_COMPRESOR ||
                     sensor?.tipo_sensor === SensorType.ESTADO_TORNILLO ||
                     sensor?.tipo_sensor === SensorType.ESTADO_BOMBA  
                    ) && (
                        <EstadoComponent key={`${sensor.id}-vent`} propsSensorEstado={sensor} />
                    ) 
                ))
            )}
        </Box>

        {/* Parte Mesnajes General:solo 1 subcomponente*/}
        <Box 
            display="flex"
            justifyContent="left"
            alignItems="center"
            gap={1} 
            mb={1}
        >
            { propsCamara.sensores?.length > 0 && (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra Mensaje de Funcionamiento
                    sensor?.tipo_sensor === SensorType.MENSAJE_FUNCIONAMIENTO && (
                        <MensajeComponent key={`${sensor.id}-msg`} propsSensor={sensor} />
                    ) 
                ))
            )}
        </Box>
    </Box>
    )
}

